export const Currency = [
    'USD',
    'EUR',
    'CUP'
]